import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {Toast} from '@ui/lib/toast'
import {FtrF19Page} from './FtrF19Page'

const root = document.getElementById('root')
if (root) {
	createRoot(root).render(
		<StrictMode>
			<Toast.Provider>
				<FtrF19Page />
			</Toast.Provider>
		</StrictMode>,
	)
}
